import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';
import {FormControl, FormGroup} from "@angular/forms";
import { Subject } from 'rxjs';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import { HttpClient } from '@angular/common/http';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
const longText = `Mega Man X, known in Japan as Rockman X,[a] is an action-platform video game developed and published by Capcom for the Super Nintendo Entertainment System (SNES).
  1
  2
  3`;

@Component({
  selector: 'workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss']
})
export class WorkflowComponent implements OnInit {
  // INICIO DE AUTISZE
  public longText = longText;
  public minRows = 3;
  public maxRows = 4;
  public onlyGrow = true;
  public useImportant = true;

  reactiveText = new FormControl(longText);
  reactiveForm = new FormGroup({
    reactiveText: new FormControl(longText)
  });
  // FIN AUTOSIZE

  dataDef = [
    {
      position: 1, 
      tittle: 'WIZARD.DEFINICIONES_TABLA.DEF1.TITLE_DEF',
      definicion: 'WIZARD.DEFINICIONES_TABLA.DEF1.DEF', 
    },{
      position: 2, 
      tittle: 'WIZARD.DEFINICIONES_TABLA.DEF2.TITLE_DEF',
      definicion: 'WIZARD.DEFINICIONES_TABLA.DEF2.DEF', 

    },{
      position: 3, 
      tittle: 'WIZARD.DEFINICIONES_TABLA.DEF3.TITLE_DEF',
      definicion: 'WIZARD.DEFINICIONES_TABLA.DEF3.DEF', 

    },{ 
      position: 4, 
      tittle: 'WIZARD.DEFINICIONES_TABLA.DEF4.TITLE_DEF',
      definicion: 'WIZARD.DEFINICIONES_TABLA.DEF4.DEF', 
 
    },{
      position: 5,
      tittle: 'WIZARD.DEFINICIONES_TABLA.DEF5.TITLE_DEF',
      definicion: 'WIZARD.DEFINICIONES_TABLA.DEF5.DEF',  
   
    }
    
  ]
  private _unsubscribeAll: Subject<any>;
  idiomaBanner:any;
  constructor(
    private idiomasService: IdiomasServiceN35,
    private activated: ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService) { 
      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
  
      this._unsubscribeAll = new Subject();
      lang_wizard.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    }


  

  ngOnInit() {
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }
  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang; 
    switch(idioma){
      case 'es': this.idiomaBanner = idioma; 
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-04.png';
  }

  

  changeNgModel() {
    this.longText += "\n next";
  }

  updateReactiveText() {
    const current = this.reactiveText.value;
    this.reactiveText.setValue(current + "\n next");
  }

  updateReactiveFormText() {
    const current = this.reactiveForm.value.reactiveText;
    this.reactiveForm.setValue({
        reactiveText: current + "\n next"
    });
  }

}
